// API-Konfiguration
const API_CONFIG = {
  // Leer = Same-Origin (Frontend-Proxy leitet /api an Backend weiter)
  baseURL: process.env.REACT_APP_API_URL || '',
  
  // Timeout für Anfragen in Millisekunden
  timeout: 10000,
  
  // Standard-Headers
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

export default API_CONFIG; 